import React from 'react'
import { Box, Stack, CircularProgress, Paper, Skeleton, Grid, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

function LoadingInformation() {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  return (
    <Paper
      elevation={0}
      customBorder
      sx={{
        p: 4.5,
      }}
    >
      <Skeleton variant="text" height={32} sx={{ fontSize: '1rem', mb: 3.5 }} />
      <Box>
        <Stack direction={matches ? 'row' : 'column'} spacing={1.5}>
          <Box sx={{ mb: matches && 2.5 }}>
            <Skeleton variant="rounded" width={150} height={255} />
          </Box>
          <Box sx={{ width: matches ? 'calc(100% - 150px)' : '100%', py: 2 }}>
            <Typography variant="subtitle2" sx={{ color: '#fff!important' }}>
              <Skeleton />
            </Typography>
            <Typography variant="subtitle2" sx={{ color: '#fff!important' }}>
              <Skeleton width="80%" />
            </Typography>
            <Typography variant="subtitle2" sx={{ color: '#fff!important' }}>
              <Skeleton width="60%" />
            </Typography>
            <Typography width="40%" variant="subtitle2" sx={{ color: '#fff!important' }}>
              <Skeleton />
            </Typography>
          </Box>
        </Stack>
      </Box>
      <Typography variant="body2">
        <Skeleton width="40%" />
        <Skeleton width="80%" />
      </Typography>
      <Box sx={{ mt: 4.0 }}>
        <Skeleton variant="rounded" height={36} />
      </Box>
    </Paper>
  )
}

export default LoadingInformation
